export default (initialState = {}) => {
  return () => {
    return {
      date: null,
      invc_id: null,
      invc_number: "",
      lineitems: [],
      number: "",
      po_id: null,
      status_cd: "received",
      status: "Received",
      remarks: "",
      tcs: {},
      total_amount: null,
      total_tax: null,
      vehicle_number: "",
      ...initialState,
    };
  };
};
